/**
 * Routes that are lead-flow concepts.
 *
 * The site header (src/components/RouteHeader.tsx) renders NOTHING on these:
 * a concept's landing page brings its own navigation, and its intake flow gets
 * the minimal logo-and-phone header from LeadFlowPage. Without this the full
 * site nav stacks on top — which shipped on Coverage Check for a day, offering
 * "About Us", "Careers" and "COMPARE QUOTES" above a form whose whole job is to
 * be finished.
 *
 * `npm run new-concept` appends to this list. Keep one prefix per line.
 */
export const LEAD_FLOW_ROUTE_PREFIXES: string[] = [
  "/coverage-check",
  "/tax-appeal-demo",
  "/lead-flow-demo",
  "/property-tax-appeal",
];

export function isLeadFlowRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return LEAD_FLOW_ROUTE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}
